import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';

/**
 * @class ContextVisualizer
 */
export default class ContextVisualizer {
    /**
     * Sets opacity value for inactive context layer (between 0 and 1)
     * @type {number}
     */
    PASSIVE_OPACITY = 0.45;

    /**
     * Initializes the context manager
     *
     * @param {ContextManager} contextManager
     * @param {LayerManager} layerManager
     */
    constructor(contextManager, layerManager) {
        this.contextManager = contextManager;
        this.layerManager = layerManager;

        this.contextManager.on('switch', (cm, context) => this._highlight(context), this);
        this.contextManager.on('add', () => this._highlight(contextManager.getCurrentContext()), this);
        this._highlight(contextManager.getCurrentContext());
    }

    /**
     * highlights new context's layer and
     * darkens previous context's layer
     *
     * @param {Context} newContext
     * @private
     */
    _highlight(newContext) {
        this._disableAllContexts();
        this._enableContext(newContext);
    }

    _disableAllContexts() {
        this.contextManager
            .getContexts()
            .forEach((context) => {
                this.layerManager
                    .getLayerByItem(context.getItem())
                    .getElement()
                    .attr('opacity', this.PASSIVE_OPACITY);
            });
    }

    _enableContext(context) {
        if (!context) return;

        this.layerManager
            .getLayerByItem(context.getItem())
            .getElement()
            .removeAttr('opacity');
    }
}

namespace('Ofcs.Editor.Context');
window.Ofcs.Editor.Context.ContextVisualizer = ContextVisualizer;
